import index from "../components/index";

export default [
  {
    path: "/steps",
    component: index,
    meta: { auth: true },
  },
];
